// ABOUTME: Utility functions for shadcn/ui components
// ABOUTME: cn() merges Tailwind classes with clsx for conditional styling

import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// Custom font-size tokens from @theme have to be declared, or tailwind-merge reads
// `text-control` as a text COLOUR and lets it drop the real colour that came before it
// (a primary button silently loses `text-primary-foreground`).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["control"] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
